(function (window, document) {
  const SHEET_ID = '1UBrAgYnlJ7LhZ4srxAS9DW37xX4GGRcFVMNjUnw7HN4';
  const PINCODE_KEY = 'currentPincode';
  const SLA_KEY = 'currentPincodeSla';
  const EVENT_UPDATED = 'er:pincode-updated';
  const EVENT_LOADING = 'er:pincode-loading';
  const CARD_HTML =
    '<div class="product-card__edd" hidden>' +
    '<svg class="product-card__edd-icon" width="23" height="16" aria-hidden="true" focusable="false"><use href="#er-edd-truck"></use></svg>' +
    '<span class="product-card__edd-text">Delivery by <strong class="product-card__edd-date"></strong></span>' +
    '</div>';

  const state = {
    pincode: '',
    slaDays: null,
    serviceable: false,
    dateShort: '',
    loading: false,
  };

  const slaCache = new Map();
  const slaInflight = new Map();
  let initPromise = null;
  let applyInflight = null;
  let applyPin = '';
  let applyGen = 0;
  let uiBound = false;

  const isValidPincode = (value) => /^\d{6}$/.test(String(value || '').trim());

  const getPublicState = () => ({
    pincode: state.pincode,
    slaDays: state.slaDays,
    serviceable: state.serviceable,
    dateShort: state.dateShort,
    loading: state.loading,
  });

  const dispatch = (name) => {
    document.dispatchEvent(new CustomEvent(name, { detail: getPublicState() }));
  };

  const formatDateShort = (daysToAdd) => {
    const date = new Date();
    date.setDate(date.getDate() + Number(daysToAdd));
    return date.getDate() + ' ' + date.toLocaleString('en-US', { month: 'long' });
  };

  const storageGet = (key) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };

  const storageSet = (key, value) => {
    try {
      if (value == null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {}
  };

  const digits = (value) => String(value || '').replace(/\D/g, '');

  const pinFrom = (value) => {
    if (value && typeof value === 'object') {
      return (
        pinFrom(value.Postal) ||
        pinFrom(value.postcode) ||
        pinFrom(value.postalCode) ||
        pinFrom(value.postal) ||
        pinFrom(value.Match_addr) ||
        pinFrom(value.LongLabel)
      );
    }

    const text = String(value == null ? '' : value);
    const matches = text.match(/\d{6}/g) || [];
    for (let i = 0; i < matches.length; i++) {
      if (isValidPincode(matches[i])) return matches[i];
    }
    const cleaned = digits(text);
    return isValidPincode(cleaned) ? cleaned : '';
  };

  const fetchWithTimeout = async (url, ms) => {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), ms);
    try {
      const res = await fetch(url, { signal: ctrl.signal });
      if (!res.ok) throw new Error('request-failed');
      return res;
    } finally {
      clearTimeout(timer);
    }
  };

  const fetchJson = async (url, ms) => {
    const res = await fetchWithTimeout(url, ms);
    return res.json();
  };

  const getSlaDaysByPincode = (pincode) => {
    if (slaCache.has(pincode)) return Promise.resolve(slaCache.get(pincode));
    if (slaInflight.has(pincode)) return slaInflight.get(pincode);

    const query = 'select A, D where A = ' + pincode + ' limit 1';
    const url =
      'https://docs.google.com/spreadsheets/d/' +
      SHEET_ID +
      '/gviz/tq?sheet=Sheet1&tq=' +
      encodeURIComponent(query);

    const request = fetchWithTimeout(url, 8000)
      .then((res) => res.text())
      .then((resText) => {
        const json = JSON.parse(resText.substring(47).slice(0, -2));
        const cell =
          json.table && json.table.rows && json.table.rows[0] && json.table.rows[0].c && json.table.rows[0].c[1];
        const value = cell && cell.v != null ? cell.v : null;
        slaCache.set(pincode, value);
        return value;
      })
      .finally(() => slaInflight.delete(pincode));

    slaInflight.set(pincode, request);
    return request;
  };

  const applyState = (pincode, slaValue) => {
    const slaDays = parseInt(slaValue, 10);
    const serviceable = slaValue != null && slaValue !== '' && !isNaN(slaDays);

    state.pincode = pincode;
    state.slaDays = serviceable ? slaDays : null;
    state.serviceable = serviceable;
    state.dateShort = serviceable ? formatDateShort(slaDays) : '';

    storageSet(PINCODE_KEY, pincode);
    storageSet(SLA_KEY, serviceable ? String(slaDays) : null);

    dispatch(EVENT_UPDATED);
    refreshCardEdd();
  };

  const restoreSavedPincode = () => {
    const saved = storageGet(PINCODE_KEY);
    if (!isValidPincode(saved)) return false;

    const cachedSla = storageGet(SLA_KEY);
    if (cachedSla != null && cachedSla !== '') {
      if (state.pincode !== saved || String(state.slaDays) !== String(cachedSla)) {
        applyState(saved, cachedSla);
      }
    } else if (state.pincode !== saved) {
      state.pincode = saved;
      dispatch(EVENT_UPDATED);
    }
    return true;
  };

  const paintHeaderLabels = () => {
    const pin = isValidPincode(state.pincode) ? state.pincode : storageGet(PINCODE_KEY);
    const showPin = isValidPincode(pin) ? pin : '';
    if (showPin && state.pincode !== showPin) state.pincode = showPin;

    const labels = document.querySelectorAll('[data-er-pincode-label]');
    for (let i = 0; i < labels.length; i++) {
      const label = labels[i];
      const mobile = label.closest('.header-pincode--mobile');
      label.textContent = showPin || (mobile ? 'Enter Pincode' : 'ENTER PINCODE');
    }
  };

  const applyPincode = async (pincode) => {
    const pin = String(pincode || '').trim();
    if (!isValidPincode(pin)) return getPublicState();
    if (applyInflight && applyPin === pin) return applyInflight;

    const gen = ++applyGen;
    applyPin = pin;
    state.loading = true;
    dispatch(EVENT_LOADING);

    applyInflight = getSlaDaysByPincode(pin)
      .then((slaValue) => {
        if (gen !== applyGen) return getPublicState();
        applyState(pin, slaValue);
        return getPublicState();
      })
      .catch((err) => {
        if (gen !== applyGen) return getPublicState();
        if (isValidPincode(pin)) {
          state.pincode = pin;
          storageSet(PINCODE_KEY, pin);
          paintHeaderLabels();
        }
        throw err;
      })
      .finally(() => {
        if (gen !== applyGen) return;
        state.loading = false;
        applyInflight = null;
        applyPin = '';
        dispatch(EVENT_LOADING);
      });

    return applyInflight;
  };

  const detectFromIp = async () => {
    const sources = ['https://ipwho.is/', 'https://ipapi.co/json/'];
    const probes = sources.map((url) =>
      fetchJson(url, 2500).then((data) => {
        const postcode = digits(data.postal);
        if (!isValidPincode(postcode)) throw new Error('no-pin');
        return postcode;
      })
    );

    try {
      return await Promise.any(probes);
    } catch (e) {
      return null;
    }
  };

  const getGpsCoords = () =>
    new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(null);
        return;
      }

      const request = (options, onFail) => {
        navigator.geolocation.getCurrentPosition(
          (pos) =>
            resolve({
              lat: pos.coords.latitude,
              lon: pos.coords.longitude,
            }),
          onFail,
          options
        );
      };

      request({ enableHighAccuracy: true, timeout: 12000, maximumAge: 300000 }, (err) => {
        if (err && err.code === 1) {
          resolve(null);
          return;
        }
        request({ enableHighAccuracy: false, timeout: 15000, maximumAge: 600000 }, () => resolve(null));
      });
    });

  const reverseGeocodePin = async (lat, lon) => {
    const latEnc = encodeURIComponent(lat);
    const lonEnc = encodeURIComponent(lon);
    const sources = [
      'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=json&location=' +
        lonEnc +
        ',' +
        latEnc,
      'https://photon.komoot.io/reverse?lon=' + lonEnc + '&lat=' + latEnc + '&limit=1',
      'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' +
        latEnc +
        '&longitude=' +
        lonEnc +
        '&localityLanguage=en',
    ];

    const probes = sources.map((url) =>
      fetchJson(url, 5000).then((data) => {
        const postcode =
          pinFrom(data.address) ||
          pinFrom(data.features && data.features[0] && data.features[0].properties) ||
          pinFrom(data.postcode) ||
          pinFrom(data.postalCode);
        if (!isValidPincode(postcode)) throw new Error('no-pin');
        return postcode;
      })
    );

    try {
      return await Promise.any(probes);
    } catch (e) {
      return null;
    }
  };

  const detectFromGps = async () => {
    const coords = await getGpsCoords();
    if (!coords) return null;
    return reverseGeocodePin(coords.lat, coords.lon);
  };

  const shouldAskLocationOnLoad = () => {
    const modal = document.getElementById('er-pincode-modal');
    if (!modal) return true;
    return modal.getAttribute('data-show-location-prompt') !== 'false';
  };

  const detectPincode = async () => {
    if (!shouldAskLocationOnLoad()) return null;
    const gpsPin = await detectFromGps();
    if (gpsPin) return gpsPin;
    return detectFromIp();
  };

  const refreshCardEdd = (root) => {
    const nodes = (root || document).querySelectorAll('.product-card__edd');
    const show = Boolean(state.pincode && state.serviceable && state.dateShort);

    for (let i = 0; i < nodes.length; i++) {
      const el = nodes[i];
      const dateEl = el.querySelector('.product-card__edd-date');
      if (show && dateEl) dateEl.textContent = state.dateShort;
      el.hidden = !show;
    }
  };

  const ensureCardMarkup = (card) => {
    if (!card || card.querySelector('.product-card__edd')) return;
    const target = card.querySelector('.product-card__content') || card;
    target.insertAdjacentHTML('beforeend', CARD_HTML);
  };

  const hydrate = (root) => {
    const scope = root || document;
    const cards = scope.querySelectorAll('.product-card');
    for (let i = 0; i < cards.length; i++) ensureCardMarkup(cards[i]);
    refreshCardEdd(scope);
  };

  const init = () => {
    if (initPromise) return initPromise;

    initPromise = (async () => {
      if (restoreSavedPincode()) {
        paintHeaderLabels();
        try {
          await applyPincode(state.pincode);
        } catch (e) {}
        return getPublicState();
      }

      const detected = await detectPincode();
      if (detected) {
        try {
          await applyPincode(detected);
        } catch (e) {}
      }
      return getPublicState();
    })();

    return initPromise;
  };

  const getModalEls = () => ({
    modal: document.getElementById('er-pincode-modal'),
    input: document.getElementById('er-pincode-modal-input'),
    checkBtn: document.getElementById('er-pincode-modal-check'),
    locBtn: document.getElementById('er-pincode-modal-location'),
    resultEl: document.getElementById('er-pincode-modal-result'),
    loader: document.querySelector('#er-pincode-modal .er-pincode-modal__loader'),
  });

  const bindHeaderUi = () => {
    const syncCheckBtn = () => {
      const { checkBtn, input } = getModalEls();
      if (!checkBtn || !input) return;
      checkBtn.disabled = !isValidPincode(input.value.trim());
    };

    const openModal = () => {
      const { modal, input, resultEl } = getModalEls();
      if (!modal || !input) return;
      if (state.pincode) input.value = state.pincode;
      if (resultEl) resultEl.hidden = true;
      syncCheckBtn();
      modal.hidden = false;
      document.body.classList.add('er-pincode-modal-open');
      setTimeout(() => input.focus(), 30);
    };

    const closeModal = () => {
      const { modal } = getModalEls();
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('er-pincode-modal-open');
    };

    const updateLabels = paintHeaderLabels;

    const updateResult = () => {
      const { resultEl } = getModalEls();
      if (!resultEl) return;
      if (state.pincode && !state.serviceable) {
        resultEl.hidden = false;
        resultEl.textContent = 'Delivery is Not Serviceable';
        return;
      }
      resultEl.hidden = true;
    };

    const showModalError = (message) => {
      const { resultEl } = getModalEls();
      if (!resultEl) return;
      resultEl.hidden = false;
      resultEl.textContent = message;
    };

    const finishApply = (detail) => {
      updateResult();
      if (detail && detail.pincode && detail.serviceable) closeModal();
    };

    const runCheck = async () => {
      const { input, checkBtn, loader } = getModalEls();
      if (!input || !checkBtn) return;
      const pin = input.value.trim();
      if (!isValidPincode(pin)) return;
      checkBtn.disabled = true;
      if (loader) loader.classList.add('active');
      try {
        finishApply(await applyPincode(pin));
      } catch (err) {
        showModalError('Unable to check delivery right now.');
      } finally {
        if (loader) loader.classList.remove('active');
        syncCheckBtn();
      }
    };

    const runLocation = async () => {
      const { locBtn, input, loader } = getModalEls();
      if (locBtn) locBtn.disabled = true;
      if (loader) loader.classList.add('active');
      try {
        let pin = await detectFromGps();
        if (!pin) pin = await detectFromIp();
        if (!pin) {
          showModalError('Unable to detect location. Enter pincode instead.');
          return;
        }
        if (input) input.value = pin;
        syncCheckBtn();
        finishApply(await applyPincode(pin));
      } catch (err) {
        showModalError('Unable to detect location. Enter pincode instead.');
      } finally {
        if (loader) loader.classList.remove('active');
        if (locBtn) locBtn.disabled = false;
        syncCheckBtn();
      }
    };

    if (!uiBound) {
      uiBound = true;

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-er-pincode-open]')) {
          openModal();
        } else if (event.target.closest('[data-er-pincode-close]')) {
          closeModal();
        } else if (event.target.closest('#er-pincode-modal-check')) {
          runCheck();
        } else if (event.target.closest('[data-er-pincode-location]')) {
          runLocation();
        }
      });

      document.addEventListener('keydown', (event) => {
        const { modal, input, checkBtn } = getModalEls();
        if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
        if (event.key === 'Enter' && event.target === input && checkBtn && !checkBtn.disabled) {
          event.preventDefault();
          runCheck();
        }
      });

      document.addEventListener('input', (event) => {
        const { input } = getModalEls();
        if (event.target !== input || !input) return;
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
        syncCheckBtn();
      });

      document.addEventListener(EVENT_UPDATED, () => {
        const { input } = getModalEls();
        updateLabels();
        updateResult();
        if (input && state.pincode) input.value = state.pincode;
        syncCheckBtn();
      });

      document.addEventListener(EVENT_LOADING, () => {
        const headers = document.querySelectorAll('.header-pincode');
        for (let i = 0; i < headers.length; i++) {
          headers[i].classList.toggle('is-loading', state.loading);
        }
        const { loader } = getModalEls();
        if (loader) loader.classList.toggle('active', state.loading);
      });
    }

    updateLabels();
    updateResult();
    syncCheckBtn();
  };

  const syncUi = () => {
    restoreSavedPincode();
    bindHeaderUi();
    hydrate();
  };

  const boot = () => {
    restoreSavedPincode();
    bindHeaderUi();
    hydrate();
    init();
  };

  document.addEventListener('shopify:section:load', syncUi);
  window.addEventListener('pageshow', syncUi);
  window.addEventListener('pagereveal', syncUi);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') syncUi();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ErPincode = {
    isValid: isValidPincode,
    getState: getPublicState,
    applyPincode,
    init,
    hydrate,
    refreshCardEdd,
    syncUi,
    cardHtml: CARD_HTML,
    EVENT_UPDATED,
    EVENT_LOADING,
  };
})(window, document);
